<template>
  <div class="tabMail">
    <div class="fieldGroup">
      <div class="groupFieldTitle">
        <span>Departments</span>
        <button type="button" @click="onAddItem">
          <svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
        </button>
      </div>
      <template v-for="({ value, id }, idx) in departments">
        <div class="groupField_wrap" :key="idx">
          <field
            :classError="getError(idx)"
            margin="0 0 10px 0"
            width="346px"
            label="Department"
            placeholder="Enter department"
            @updateInput="onInput($event, id)"
            :setInputValue="value"
            :idx="idx"
            is-required
            is-trim
          ></field>
          <button
            type="button"
            class="deleteItem"
            @click="onDeleteItem(idx)"
          >
            <svg-sprite
              width="20"
              height="20"
              icon-id="deleteItem"
            ></svg-sprite>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
	name: "DepartmentsSettings",
	props: {
		valid: Object,
		departments: Array,
		tabPermissionId: Number,
	},
	methods: {
		getError(idx) {
			return this.valid.departments?.$each?.$iter[idx]?.value
				?.$error;
		},
		onInput(value) {
			this.$emit("updateDepartmentsListEdit", value);
		},
		onAddItem() {
			const item = { id: null, value: null };
			this.$emit("updateDepartmentsList", { item });
		},
		onDeleteItem(idx) {
			this.$emit("updateDepartmentsListDelete", idx);
		},
	},
};
</script>

<style scoped lang="scss">
.warning_block {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #f49741;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  span {
    margin-left: 10px;
    display: inline-block;
  }
}

.switch {
  margin-bottom: 20px;
}

.deleteItem {
  margin-left: 20px;
  color: #19bc38;

  &[disabled] {
    cursor: default;
    color: rgba(255, 255, 255, 0.6);
  }
}

.groupField {
  background: #1c1c28;
  width: 100%;
  max-width: 560px;

  &Title {
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #8f90a6;
    width: 100%;
    display: flex;
    justify-content: space-between;
    min-width: 380px;

    button {
      height: 20px;
      color: #19bc38;

      &[disabled] {
        cursor: default;
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  &_wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
